import React, { useState, useRef } from "react"
import { Alert } from "react-bootstrap"
import request from "../utils/request"

import "./Form.scss"

const Form = () => {
    const inputFile = useRef(null);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [linkedIn, setLinkedIn] = useState('');
    const [email, setEmail] = useState('');
    const [location, setLocation] = useState('Without Preferences');
    const [userMessage, setMessage] = useState('');
    const [attachment, setAttachment] = useState({
        fileName: "",
        fileContent: ""
    });
    const [gdprApprove, setGdprApprove] = useState(false);
    const [isBusy, setBusy] = useState(false);
    const [successAlert, setSuccessAlert] = useState({
        show: false,
    });
    const [warningAlert, setWarningAlert] = useState({
        text: '',
        show: false,
    });

    /**
     * Handles click on attachment picker select file
     * @param {event} event from attachment picker
     */
    const handleFileUpload = (event) => {
        const { files } = event.target;
        if (files && files.length) {
            const file = files[0];
            setAttachment(file);
            var reader = new FileReader();
            reader.onload = (e) => {
                setAttachment({ fileName: file.name, fileContent: e.target.result});
                console.log(attachment);
            }
            reader.readAsDataURL(file);
        } else {
            setAttachment({ fileName: "", fileContent: "" });
        }
    };

    /**
     * Triggers attachment picker to open up
     */
    const onUploadButtonPress = () => {
        inputFile.current.click();
    };

    /**
     * Verifies user form and handles all error messages for user
     */
    const verifyForm = () => {
        const jobReqId = window.location.search.substring(1).split("=")[1];
        const phoneRegex = new RegExp("^[+]?[()/0-9]{9,}$");
        var canSend = true;
        var message = "Ve formuláři nám chybí nebo jsou chybné některé údaje. Doplňte je prosím.";
        
        if (firstName === '') {
            canSend = false;
            message += "\n- Vyplňte prosím vaše jméno.";
        } 
        
        if (lastName === '') {
            canSend = false;
            message += "\n- Vyplňte prosím vaše příjmení.";
        }

        if (phoneNumber === '') {
            canSend = false;
            message += "\n- Vyplňte prosím vaše číslo.";
        } else if (!phoneRegex.test(phoneNumber)) {
            canSend = false;
            message += "\n- Uvedené telefonní číslo je ve špatném formátu. Musí obsahovat minimálně 9 číslic.";
        }

        if (email !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            canSend = false;
            message += "\n- Váš e-mail má špatný formát, zkontrolujte si jej prosím.";
        }

        if (!gdprApprove) {
            canSend = false;
            message += "\n- Pročtěte si prosím a potvrďte souhlas se zpracování osobních údajů.";
        }

        if (!jobReqId) {
            canSend = false;
            message += "\n- Prosím navigujte se znovu na stránku z důvodu zlého načtení čísla rekvizice.";
        }

        if (canSend) {
            sendForm({
                firstName: firstName,
                lastName: lastName,
                phoneNumber: phoneNumber,
                email: email,
                linkedIn: linkedIn ,
                location: location,
                message: userMessage,
                attachment: attachment,
                jobReqId: jobReqId
            });
            setWarningAlert({text: "", show: false});
        } else {
            window.scrollTo({
                top: 350,
                left: 0,
                behavior: 'smooth'
              });
            setWarningAlert({text: message, show: true});
        }
    }

    /**
     * Sends completed object to the backend side of app
     * @param {Object} objToSend 
     */
    const sendForm = async (objToSend) => {
        setBusy(true);
        request.postRequest("/createApplication", objToSend).then((response) => {
            setBusy(false);
            if (!response || response.status !== 200) {
                setBusy(false);
                setWarningAlert({text: "Na naší straně došlo k poruše. Kontaktujte prosím naší podporu, děkujeme.", show: true});
            } else {
                setBusy(false);
                setSuccessAlert({show: true});
            }
        });
    }

    return (
        <section id="form-section" className="page-section">
            <div className="container">
            <Alert className="success-alert" variant="success" style={{display: successAlert.show === true ? "" : "none"}}>
                <p>
                    Vaše žádost byla úspěšně odeslána. <br></br>Děkujeme, že jste se přihlásili a chcete se stát součástí našeho týmu. V nejbližší době vás budeme kontaktovat.<br></br>Zajímá vás, co se bude dít dál? Na to se můžete podívat <a className="linkSuccess" target="_blank" href="https://prace.foxconn.cz/content/Proces-naboru/?locale=cs_CZ">tady</a>.
                </p>
                <a className="btn backToPositions-button" href="https://prace.foxconn.cz/search">Zpět na seznam volných míst</a>
            </Alert>
            <div className="background-holder top-left" style={{display: successAlert.show === true ? "none" : ""}}>
            <div className="background-holder top-right">
            <div className="background-holder bottom-left">
            <div className="background-holder bottom-right">
                <div className="container site-content">
                    <div className="indicator" style={{display: isBusy === true ? "" : "none"}}>
                    <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                    </div>
                    {/* Title */}
                    <div className="site-title">
                            <h2 className="title-text">
                                Staňte se součástí naší
                                <span className="title-tag"> #foxconnfamily</span>
                                !
                            </h2>
                        <h3 className="title-desc">Pošlete životopis nebo odkaz na LinkedIn ještě dnes!</h3>
                    </div>
                    <div className="row content-center">
                        <Alert className="warning-alert" variant="warning" style={{display: warningAlert.show === true ? "" : "none"}}>
                            <button type="button" className="closeBtn" onClick={() => setWarningAlert({text: "contact.alert.noData", show: false})}>
                                <i className="fas fa-times"></i>
                            </button>
                            <div className='new-line'>{warningAlert.text}</div>
                        </Alert>
                    </div>
                    {/* Inputs */}
                    <div className="row content-center">
                        <div className="content-row">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <label className="input-label">Jméno*:</label>
                                    <div className="" id="wrapper-name">
                                        <input type="text" onChange={event => setFirstName(event.target.value)} value={firstName} id="name" placeholder="Vaše jméno.." className="medium-input" name="name"/>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 right-input">
                                    <label className="input-label">Příjmení*:</label>
                                    <div className="" id="wrapper-name">
                                        <input type="text" onChange={event => setLastName(event.target.value)} value={lastName} id="lastname" placeholder="Vaše příjmení.." className="medium-input" name="name"/>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div className="content-row">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <label className="input-label">Telefonní číslo*:</label>
                                    <div className="" id="wrapper-name">
                                        <input type="text" onChange={event => setPhoneNumber(event.target.value)} value={phoneNumber} id="name" placeholder="Vaše telefonní číslo.." className="medium-input" name="name"/>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 right-input">
                                    <label className="input-label">Odkaz na LikedIn profil:</label>
                                    <div className="" id="wrapper-name">
                                        <input type="text" onChange={event => setLinkedIn(event.target.value)} value={linkedIn} id="name" placeholder="Odkaz na váš LinkedIn profil.." className="medium-input" name="name"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-row">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <label className="input-label">Email:</label>
                                    <div className="" id="wrapper-name">
                                        <input type="text" onChange={event => setEmail(event.target.value)} value={email} id="lastname" placeholder="Vaš email.." className="medium-input" name="name"/>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div className="content-row">
                            <label className="middle-label">Preferovaná lokalita práce</label>
                            <div className="checkboxes row">
                                <div className="col-12 col-lg-4">
                                    <div className="form-check">
                                        <input type="radio" className="ch" checked={location === "Pardubice" ? true : false} onChange={() => setLocation("Pardubice")} value="Pardubice" id="location_check1" name="location_check"/>
                                        <label className="form-check-label">Pardubice</label>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4">
                                    <div className="form-check">
                                        <input type="radio" className="ch" checked={location === "Kutná Hora" ? true : false} onChange={() => setLocation("Kutná Hora")} value="Kutná Hora" id="location_check2" name="location_check"/>
                                        <label className="form-check-label">Kutná Hora</label>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4">
                                    <div className="form-check">
                                        <input type="radio" className="ch" checked={location === "Praha" ? true : false} onChange={() => setLocation("Praha")} value="Praha" id="location_check3" name="location_check"/>
                                        <label className="form-check-label">Praha</label>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4">
                                    <div className="form-check">
                                        <input type="radio" className="ch" checked={location === "Without Preferences" ? true : false} onChange={() => setLocation("Without Preferences")} value="Je mi to jedno" id="location_check3" name="location_check"/>
                                        <label className="form-check-label">Je mi to jedno</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-row">
                            <label className="input-label">Příloha:</label>
                            <div>
                            <input className="attachment-picker" accept="image/png, image/jpeg, img/jpg, .pdf, .doc, .docx, .txt" ref={inputFile} onChange={handleFileUpload} type="file"/>
                            <button id="attachment-trigger" className="attachment-trigger btn" type="file" onClick={() => onUploadButtonPress()}>
                                {attachment.fileName !== "" ? attachment.fileName : "Přidat přílohu (CV/životopis, atp.)"}
                                <span>Přidat přílohu</span>
                            </button>
                            </div>
                        </div>
                        <div className="content-row">
                            <label className="input-label">Nechte nám vzkaz:</label>
                            <textarea id="note" rows="5" placeholder="Váš vzkaz:" onChange={event => setMessage(event.target.value)} value={userMessage} className="col-md-12  form-control" name="note"></textarea>
                        </div>
                        <div className="content-row">
                            <label className="input-label">Zpracování osobních údajů:</label>
                            <div className="gdpr-label">
                                <input type="checkbox" onChange={event => setGdprApprove(event.target.checked)} className="ch" id="grdp-checkbox" name="location_check"/>
                                <p className="">
                                    Souhlasím se <a className="link" target="_blank" href="https://prace.foxconn.cz/content/gdpr/?locale=cs_CZ&previewLink=true&referrerSave=false">zpracováním osobních údajů</a> za podmínek a v rozsahu uvedeném v Souhlasu výše, se kterým jsem se řádně seznámil/a.
                                </p>
                            </div>
                        </div>
                        <div className="content-row">
                            <input type="submit" onClick={() => verifyForm()} value="Odeslat" id="send" className="btn send-button button-spacer" name="send"/>
                            <input type="submit" onClick={() => window.history.back(-1)} value="Zpět" id="back" className="btn send-button" name="back"/>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            </div>
            </div>
            </div>
        </section>
    )
}

export default Form